import '.dr{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.ds{padding-left:1.5rem;}.ssr-plugin'
import '.dt{margin:1rem 0;}.ssr-plugin'
import '.du{color:var(--gray-700);}.ssr-plugin'
import '.dv{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="dr ds dt du dv"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
